import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { RouteWithLayout } from "../services/routing";
import store from "../redux/store";
import { Settings, UserLocation } from "../redux/actions";
//import "../pages/abstract/grid_view.scss";

//Layouts
import AdminLayout from "../layout/admin_layout";
import AuthLayout from "../layout/auth_layout";
import AdminLayoutMock from "../layout/admin_layout_mock";
import Landing from "../pages/landing/landing";
import { connectWithStore } from "../services/redux";
import { updateUser } from "../services/api/user";
import GoogleLogin from "../pages/sso/google_login";
import { SkeletonRows } from "../components/skeleton/skeleton";

// ponytail: this import exists to keep a module OUT of the lazy chunks, not to
// use it here. question_renderer is the draft-js family (editor, four plugins,
// the decorators) plus the answer widgets, and 18 of the 33 route chunks reach
// it. Webpack 4 caps an async chunk at `splitChunks.maxAsyncRequests: 5`, and
// CRA 3 exposes no way to raise it without ejecting, so it cannot hoist a
// 19-way shared subtree — it copies it instead. Measured: async-only put
// DraftEditor in 18 chunks and took the build from 9.9 MB to 43.7 MB of JS.
// One sync edge puts it back in the vendor chunk, downloaded once and cached.
// The genuinely single-screen weights (the icon picker, konva, video-react,
// the job editor) stay lazy — see their *_lazy.js boundaries.
// Upgrade path: react-app-rewired + `maxAsyncRequests: 30`, if the vendor
// chunk ever matters more than the duplication does.
import "../components/question/question_renderer";

//Pages
import { recordError } from "../services/last_error";
import { ROLE } from "../services/roles";

// SAM-007: roles allowed to open the Users admin screen — same set the nav
// uses for its `/users` entry (services/menu.js). Inspectors and clients are
// redirected away instead of landing on a screen they can't use.
const USERS_SCREEN_ROLES = [
  ROLE.SYSTEM_ADMIN,
  ROLE.BUSINESS_ADMIN,
  ROLE.PROJECT_MANAGER,
];

const ShiftViewLoadState = lazy(() =>
  import("../pages/shift_view/shift_view_load_state")
);
const Auth = lazy(() => import("../pages/login/auth"));
const SignUp = lazy(() => import("../pages/register/signup")); // some comment here
const Onboarding = lazy(() =>
  import("../pages/register/onboarding_wizard/onboarding_wizard")
);
const CustomSignUp = lazy(() => import("../pages/register/custom_signup"));
const Dashboard = lazy(() => import("../pages/dashboard/dashboard"));
const Dashboard2 = lazy(() => import("../pages/dashboard/dashboard_v2"));
const Profile = lazy(() => import("../pages/my_profile/profile"));
const AppSettings = lazy(() => import("../pages/settings/settings"));
const JobTypeEditor = lazy(() => import("../pages/job_type/editor"));
const JobTypeSettings = lazy(() => import("../pages/job_type/settings"));
const CreateJobType = lazy(() => import("../pages/job_type/create_job_type"));
const ForgotPassword = lazy(() =>
  import("../pages/forgot_password/forgot_password")
);
const ResetPassword = lazy(() =>
  import("../pages/forgot_password/reset_password")
);
const Users = lazy(() => import("../pages/users/users"));
const Files = lazy(() => import("../pages/files/files"));
const Games = lazy(() => import("../pages/games/games"));
const Game = lazy(() => import("../pages/games/game"));
const Workers = lazy(() => import("../pages/workers/workers"));
const WorkerView = lazy(() => import("../pages/workers/worker_view"));
const Projects = lazy(() => import("../pages/projects/projects"));
const ProjectView = lazy(() => import("../pages/projects/project_view"));
const JobTypeAnswers = lazy(() => import("../pages/job_type/answers"));
/* const CreateInstallation = lazy(() =>
  import("../pages/installation/create_installation")
); */
const Listing = lazy(() => import("../pages/installation/listing"));
const InstanceReminder = lazy(() =>
  import("../pages/installation/instance_reminder")
);
const Privacy = lazy(() => import("../pages/privacy/privacy"));
const ErrorPage = lazy(() => import("../pages/abstract/error"));
const Reports = lazy(() => import("../pages/reports/reports"));
const ReportsView = lazy(() => import("../pages/reports/reports_view"));
const ShiftView = lazy(() => import("../pages/shift_view/shift_view"));
const InternalError = lazy(() => import("../pages/error/internal"));
const Webhooks = lazy(() => import("../pages/webhooks/webhooks"));
const Playground = lazy(() => import("../pages/playground/playground"));
const Jobs = lazy(() => import("../pages/jobs/jobs_v2"));
const AutomationLogs = lazy(() =>
  import("../pages/settings/automations/automation_logs")
);
const SettingsHome = lazy(() => import("../pages/settings/settings_home"));
const Skills = lazy(() => import("../pages/skills/skills"));
const BlueprintsSettingsPage = lazy(() =>
  import("../pages/settings/blueprints")
);
const Automations = lazy(() =>
  import("../pages/settings/automations/automations")
);
const MsAppSettingsPage = lazy(() => import("../pages/settings/app_settings"));
const SendgridSettingsPage = lazy(() => import("../pages/settings/sendgrid"));

class SamuraiFrontend extends Component {
  constructor(props) {
    super(props);

    store.dispatch(Settings.loadAppSettings());
  }

  requestLocationAccess() {
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const coords = Object.assign(
                {},
                {
                  long: position.coords.longitude,
                  lat: position.coords.latitude,
                }
              );
              this.props.dispatch(UserLocation.setLocation(coords));
              if (this.props.user.profile.id) {
                updateUser({
                  id: this.props.user.profile.id,
                  acceptedLocation: true,
                });
              }
            },
            (err) => {
              if (this.props.user.profile.id) {
                updateUser({
                  id: this.props.user.profile.id,
                  acceptedLocation: false,
                });
              }
            },
            {
              timeout: 20 * 1000,
            }
          );
        } else if (result.state === "prompt") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const coords = Object.assign(
                {},
                {
                  long: position.coords.longitude,
                  lat: position.coords.latitude,
                }
              );
              this.props.dispatch(UserLocation.setLocation(coords));
              if (this.props.user.profile.id) {
                updateUser({
                  id: this.props.user.profile.id,
                  acceptedLocation: true,
                });
              }
            },
            (err) => {
              if (this.props.user.profile.id)
                updateUser({
                  id: this.props.user.profile.id,
                  acceptedLocation: false,
                });
            },
            {
              timeout: 20 * 1000,
            }
          );
        } else if (result.state === "denied") {
          if (this.props.user.profile.id)
            updateUser({
              id: this.props.user.profile.id,
              acceptedLocation: false,
            });
        }
      });
    } else {
    }
  }

  _onGetCurrentLocation() {
    navigator.geolocation.getCurrentPosition(function (position) {
      const coords = Object.assign(
        {},
        { long: position.coords.longitude, lat: position.coords.latitude }
      );
      this.props.dispatch(UserLocation.setLocation(coords));
      if (this.props.user.profile.id) {
        updateUser({
          id: this.props.user.profile.id,
          acceptedLocation: true,
        });
      }
    });
  }

  componentDidMount() {
    const path = this.props.location && this.props.location.pathname;
    if (path && path.includes("answer")) {
      return;
    }
    this.requestLocationAccess();
  }

  componentDidCatch(error, errorInfo) {
    // Both arguments were previously omitted, which threw away the only
    // description of the failure that ever existed — see services/last_error.
    recordError(error, {
      componentStack: errorInfo && errorInfo.componentStack,
      boundary: "SamuraiFrontend",
    });

    if (
      process.env.NODE_ENV !== "development" &&
      this.props.location.pathname !== "/error/500"
    ) {
      this.props.history.push("/error/500");
    }
  }

  render() {
    // AdminLayoutMock paints the real frame (sidebar) while the route chunk
    // downloads; it used to paint it empty, so a slow route showed a frame
    // around nothing. Rows are the shape every screen under this layout
    // lands in.
    return (
      <Suspense
        fallback={
          <AdminLayoutMock>
            <SkeletonRows rows={6} />
          </AdminLayoutMock>
        }
      >
        <Switch>
          <Route
            exact={true}
            path="/"
            component={(props) => <Landing {...props} />}
          />
          <Route
            exact={true}
            path="/webhooks"
            component={(props) => <Webhooks {...props} />}
          />
          <Route
            exact={true}
            path="/job_type/answer/:id"
            component={(props) => <JobTypeAnswers {...props} />}
          />
          <Route
            exact={true}
            path="/answer/:id/:project_id"
            component={(props) => <JobTypeAnswers {...props} />}
          />
          <Route
            exact={false}
            path="/google_login"
            component={(props) => <GoogleLogin {...props} />}
          />
          <Route
            exact={true}
            path="/create_installation"
            component={Onboarding}
          />
          <Route
            exact={true}
            path="/instance_reminder"
            component={InstanceReminder}
          />
          <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/auth"
            component={Auth}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/files"
            component={Files}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/games"
            component={Games}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/games/:id"
            component={Game}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/workers"
            component={Workers}
          />
          <RouteWithLayout
            layout={AdminLayout}
            //exact={true}
            path="/worker/view/:id"
            component={WorkerView}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/automation_logs/:id"
            component={AutomationLogs}
          />
          <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/signup"
            component={SignUp}
          />
          <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/custom_signup"
            component={CustomSignUp}
          />
          <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/forgot_password"
            component={ForgotPassword}
          />
          <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/reset_password"
            component={ResetPassword}
          />
          <RouteWithLayout
            layout={AuthLayout}
            hideLogo={true}
            exact={true}
            path="/privacy_and_tou"
            component={Privacy}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/dashboard"
            component={Dashboard2}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/dashboard_old"
            component={Dashboard}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/profile"
            component={Profile}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings"
            component={SettingsHome}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/general"
            component={AppSettings}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/skills"
            component={Skills}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/apps"
            component={AppSettings}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/blueprints"
            component={BlueprintsSettingsPage}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/sendgrid"
            component={SendgridSettingsPage}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/microsoft_sso"
            component={MsAppSettingsPage}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/settings/automations"
            component={Automations}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/users"
            allowTo={USERS_SCREEN_ROLES}
            component={Users}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/users/:id"
            allowTo={USERS_SCREEN_ROLES}
            component={Users}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/projects"
            component={Projects}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/project/view/:id"
            component={ProjectView}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/project/view/:id/:dialog"
            component={ProjectView}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/job_type/editor/:id"
            component={JobTypeEditor}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/job_type/settings/:id"
            component={JobTypeSettings}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/job_type/new"
            component={CreateJobType}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/jobs"
            component={Jobs}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/jobs/:id?"
            component={Jobs}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/jobs/:id?/:dialog?"
            component={Jobs}
          />
          {/* <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/create_installation"
            component={CreateInstallation}
          /> */}
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/instances"
            component={Listing}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/reports"
            component={Reports}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/reports/:id"
            component={ReportsView}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/shifts"
            component={ShiftView}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/shifts/mini"
            component={ShiftView}
          />
          <RouteWithLayout
            layout={AuthLayout}
            exact={true}
            path="/error"
            component={ErrorPage}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/error/500"
            component={InternalError}
          />
          <RouteWithLayout
            layout={AdminLayout}
            exact={true}
            path="/shiftview/load/:id"
            component={ShiftViewLoadState}
          />
          {process.env.NODE_ENV !== "production" && (
            <RouteWithLayout
              layout={AdminLayout}
              exact={true}
              path="/playground"
              component={Playground}
            />
          )}
          {/* Anything unmatched went nowhere — <Switch> rendered null and the
              user got a blank white page. The portal's login lives at /login
              and this app's at /auth, so the single likeliest wrong URL landed
              on a blank screen that reads as "my password stopped working".
              Landing already decides where a visitor belongs (/dashboard when
              logged in, /auth when not), so reuse it. Keep this last: a
              path-less Route matches everything. */}
          <Route component={Landing} />
        </Switch>
      </Suspense>
    );
  }
}

export default withRouter(connectWithStore(SamuraiFrontend, ["user"]));
